import { all, fork } from 'redux-saga/effects';
import paginationSaga from './pagination/saga';
import collectSaga from './collect/saga';

function* supplierSaga() {
    yield all([
        fork(paginationSaga),
        fork(collectSaga),
    ]);
}

export default supplierSaga;
